<div style="position:sticky; bottom: 0; width: 100%; background-color: white">
    <ng-content></ng-content>
    <div style="height: 10px;"></div>
</div>
